//
// ImageElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElement";
import "@sas-dvr/ltjs-commons/styles/ImageScaleType";

var ImageElement = createModule("BIRD::ImageElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::VisualElement"], EventDispatcher, [
    ,
    {
        file: 7,
        alternateText: 7,
        scaleType: 4,
        variable: 7,
        url: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default ImageElement;
